import { SORTING_DIR } from "@/common/models";
import { ITableConfig } from "@/components/table/table.model";

export const table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "Information type",
      key: "name",
      spanMin: "23rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "Events",
      key: "count",
      spanMin: "10rem",
      spanMax: "15rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.DESC,
      isSortActive: true,
    },
    {
      name: "First event",
      key: "startDate",
      spanMin: "17rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
    {
      name: "Last event",
      key: "endDate",
      spanMin: "17rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.DESC,
      isSortActive: false,
    },
  ],
};
